import { Menu, MenuItem } from '@mui/material';
import Crop75Icon from '@mui/icons-material/Crop75';
import { ToggleButton } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useSlate } from 'slate-react';
import { isUrl } from '../../../helpers';
import { insertEjs } from '../../../transformers/modifyEjs';
import { EjsButtonElement } from '../../../types';
import { getEjsTemplateFromS3 } from '../../../utils';
import { notify } from "../../../../../../shared/utils/notify";

// EJS buttons, with url vars added in backend
const buttons = [
	{
		label: 'Registrieren',
		get data() {
			return { url: '<%- data.registerLink %>', text: this.label };
		},
	},
	{
		label: 'Anmelden',
		get data() {
			return { url: '<%- data.loginLink %>', text: this.label };
		},
	},
	{
		label: 'Userbereich',
		get data() {
			return { url: '<%- data.userLink %>', text: this.label };
		},
	},
];

// EJS link button toggle button
export const EjsLinkButtonButton = () => {
	// Anchor rendered menu to button
	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
	const open = !!anchorEl;

	const handleClick = (event: React.MouseEvent<HTMLElement>) => {
		setAnchorEl(event.currentTarget);
	};
	const handleClose = () => {
		setAnchorEl(null);
	};

	// Load and save button template from S3 on render
	const [template, setTemplate] = useState<string>('');
	useEffect(() => {
		const getButton = getEjsTemplateFromS3('Elements/Button.ejs');
		getButton.then((button) => {
			setTemplate(button);
		});
	}, []);

	const editor = useSlate();
	const insertButton = (input: EjsButtonElement) => {
		handleClose();
		insertEjs(editor, input);
	};

	const handleInsertCustomButton = () => {
		const url = window.prompt('Gib die URL des Links ein:');
		if (!url || !isUrl(url)) {
			notify('URL ist Ungltig.');
			return;
		}

		const text = window.prompt('Gib den Button Text ein');
		if (!text) {
			notify('Button Text ist ungltig.');
			return;
		}

		const input: EjsButtonElement = {
			type: 'ejs-button',
			ejs: template,
			data: { url, text },
			children: [{ text: `[${text}]` }],
		};

		insertButton(input);
	};

	return (
		<>
			<ToggleButton onClick={handleClick} size='small' value={''}>
				<Crop75Icon />
			</ToggleButton>
			<Menu
				anchorEl={anchorEl}
				keepMounted
				open={open}
				onClose={handleClose}
			>
				{buttons.map(({ label, data }) => {
					const input: EjsButtonElement = {
						type: 'ejs-button',
						ejs: template,
						data,
						children: [{ text: `[Button zum ${label}]` }], // Editor button placeholder text
					};
					return (
						<MenuItem
							onClick={() => insertButton(input)}
							key={label}
						>
							{label}
						</MenuItem>
					);
				})}
				<MenuItem onClick={handleInsertCustomButton}>
					Eigener Button
				</MenuItem>
			</Menu>
		</>
	);
};
